<template>
  <div class="mb-6">
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div
        v-for="(scenario, index) in scenarios"
        :key="index"
        class="rounded-lg border-l-4 p-4 bg-white border shadow-xs"
      >
        <div class="flex items-center justify-between mb-2">
          <h4 class="font-semibold text-gray-900 text-sm">{{ scenario.title }}</h4>
          <span
            class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ml-2"
            :class="scenario.covered ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'"
          >
            {{ scenario.covered ? t("covered") : t("not_covered") }}
          </span>
        </div>
        <p class="text-sm text-gray-600">{{ scenario.description }}</p>
        <p v-if="!scenario.covered && scenario.reason" class="text-xs text-red-600 mt-2 italic">
          {{ scenario.reason }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { useI18n } from "vue-i18n";

export default {
  name: "ScenarioCards",
  props: {
    scenarios: { type: Array, required: true },
  },
  setup() {
    const { t } = useI18n();
    return { t };
  },
};
</script>

<i18n src="./ScenarioCards.i18n.json"></i18n>
